import { render, staticRenderFns } from "./historyPatient.vue?vue&type=template&id=69970cc3&scoped=true"
import script from "./historyPatient.vue?vue&type=script&lang=js"
export * from "./historyPatient.vue?vue&type=script&lang=js"
import style0 from "./historyPatient.vue?vue&type=style&index=0&id=69970cc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69970cc3",
  null
  
)

export default component.exports